import Account from '@/pages/Account'

export default {
  path: '/account',
  name: 'Account',
  component: Account,
  
}



// WEBPACK FOOTER //
// ./src/router/account.js